import Service from 'ember-keyboard/services/keyboard';
import { action } from '@ember/object';
import { run } from '@ember/runloop';
import { handleKeyEventWithPropagation } from 'ember-keyboard/utils/handle-key-event';

export default class KeyboardService extends Service {
  @action
  _respond(event) {
    this._disableOnInput = true;

    if (this._disableOnInput && event.target) {
      const target = event.composedPath()[0] ?? event.target;
      const key = event.key;
      const tag = target.tagName;
      const isContentEditable =
        target.getAttribute && target.getAttribute('contenteditable') != null;

      if (
        key !== 'Escape' &&
        key !== 'ArrowDown' &&
        key !== 'ArrowUp' &&
        (isContentEditable || tag === 'TEXTAREA' || tag === 'INPUT')
      ) {
        return;
      }
    }
    run(() => {
      const { firstResponders, normalResponders } = this;
      handleKeyEventWithPropagation(event, {
        firstResponders,
        normalResponders,
      });
    });
  }
}
